<template>
  <div>
    <div style="width:120px;height:120px;" :id="id"></div>
  </div>
</template>

<script>
import chartResize from '@/mixin/chart-resize'
import { getUUID } from '../../../utils/util'
let unwatch
export default {
  mixins: [chartResize],
  name: 'NestedRing',
  components: {},
  data () {
    return {
      id: getUUID()
    }
  },
  props: {
    data: {
      type: Number,
      default: function () {
        return 0
      }
    }
  },
  myChart: null,
  methods: {
    set (data) {
      var option
      option = {
        series: [
          {
            amplitude: 10,
            type: 'liquidFill',
            radius: '72%', // 水球图的半径
            center: ['50%', '50%'], // 水球图的中心（圆心）坐标，数组的第一项是横坐标，第二项是纵坐标
            data: [0.75],
            itemStyle: {
              shadowBlur: 0
            },
            outline: {
              borderDistance: 0,
              itemStyle: {
                borderWidth: 6,
                borderColor: '#297FFE',
                shadowBlur: 10,
                shadowColor: '#08E5FF'
              }
            },
            backgroundStyle: {
              color: '#090E38', // 水球未到的背景颜色
              opacity: 0.5
            },
            label: {
              show: false,
              fontSize: 24,
              fontWeight: 600,
              color: '#FFFFFF'
            }
          }
        ]
      }

      this.myChart.setOption(option)
      // window.addEventListener('resize', function() {
      //   this.myChart.resize()
      // })
    },
    drawRingGraph (id) {
      this.myChart = echarts.init(document.getElementById(id))
      unwatch = this.$watch(
        'data',
        function (newvalue, oldvalue) {
          if (newvalue) {
            this.set(newvalue)
          }
        },
        { deep: true, immediate: true }
      )
    }
  },
  mounted () {
    this.drawRingGraph(this.id)
  },
  created () {},
  beforeDestroy () {
    if (unwatch) {
      unwatch()
      unwatch = null
    }
    if (!this.myChart) {
      this.myChart.dispose()
      this.myChart = null
    }
  }
}
</script>
<style lang="less" scoped>
</style>
